// css file
import "../styles/tailwind.css";

// Lib
import Alpine from "alpinejs";

// Utils
import { pageTransition } from "./pageTransition/pageTransition";
import { initScripts, initAlpineScripts } from "./utils/initScripts";

document.addEventListener("DOMContentLoaded", () => {
  pageTransition();
  initScripts();
  initAlpineScripts();
  Alpine.start();
});
